import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

export interface PrevNextButtonsProps {
  onPrev: () => void;
  onNext: () => void;
  hasPrev: boolean;
  hasNext: boolean;
  /** Left/right (default) or up/down chevrons. */
  orientation?: 'horizontal' | 'vertical';
  prevLabel?: ReactNode;
  nextLabel?: ReactNode;
  size?: IconButtonProps['size'];
  color?: IconButtonProps['color'];
}

/**
 * Presentational prev/next icon pair. Domain logic (list index, analytics) stays in the caller.
 */
export function PrevNextButtons({
  onPrev,
  onNext,
  hasPrev,
  hasNext,
  orientation = 'horizontal',
  prevLabel,
  nextLabel,
  size,
  color,
}: PrevNextButtonsProps) {
  const PrevIcon = orientation === 'vertical' ? KeyboardArrowUpIcon : KeyboardArrowLeftIcon;
  const NextIcon = orientation === 'vertical' ? KeyboardArrowDownIcon : KeyboardArrowRightIcon;

  const prevButton = (
    <IconButton onClick={onPrev} disabled={!hasPrev} size={size} color={color} sx={{ my: 0 }}>
      <PrevIcon />
    </IconButton>
  );
  const nextButton = (
    <IconButton onClick={onNext} disabled={!hasNext} size={size} color={color} sx={{ my: 0 }}>
      <NextIcon />
    </IconButton>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      {prevLabel != null ? (
        <Tooltip title={prevLabel}>
          <span>{prevButton}</span>
        </Tooltip>
      ) : (
        prevButton
      )}
      {nextLabel != null ? (
        <Tooltip title={nextLabel}>
          <span>{nextButton}</span>
        </Tooltip>
      ) : (
        nextButton
      )}
    </Box>
  );
}
